import React, { useCallback, useState } from 'react'
import logo from '../../../assets/sentinel-logo.png'
import SSLBadge from '../SSLBadge'
import InfoModal from '../InfoModal'
import styles from './styles.module.scss'

interface BrandBarProps {
    className?: string
}

// Logo on the left, secure badge on the right: the top of every page in the
// journey, from the landing hero through to signing and uploads. The logo
// opens a card about Sentinel Legal with a link to the main site.
const BrandBar: React.FC<BrandBarProps> = ({ className }) => {
    const [aboutOpen, setAboutOpen] = useState(false)
    // Stable, so the modal's open-state setup (focus, Esc, scroll lock) runs once
    const closeAbout = useCallback(() => setAboutOpen(false), [])

    return (
        <div className={`${styles.brandBar} ${className || ''}`}>
            <button
                type="button"
                className={styles.logo}
                onClick={() => setAboutOpen(true)}
                aria-haspopup="dialog"
                aria-label="About Sentinel Legal"
            >
                <img src={logo} alt="Sentinel Legal" />
            </button>
            <SSLBadge />
            <InfoModal
                open={aboutOpen}
                onClose={closeAbout}
                titleId="about-sentinel-title"
                // The logo up top names it, so no heading
                label="About Sentinel Legal"
                visual={<img src={logo} alt="" className={styles.modalLogo} />}
                // New tab, so leaving mid-form doesn't lose their answers
                primaryAction={{ label: 'Visit site', href: 'https://www.sentinellegal.co.uk/' }}
            >
                Authorised and regulated by the Solicitors Regulation Authority. SRA number 811792. Company number
                12826774. VAT registration number 423 9685 69.
            </InfoModal>
        </div>
    )
}

export default BrandBar
